import { registerBuiltinComponents } from "../../components/builtin/register";
import { registerComponentEffect, registerReactComponentEffect } from "../../state/actions";
import { ComponentIcon } from "../../state/modules/components-meta";
import { RuntimeCore } from "./runtime-core";
function validateComponentType(type, component) {
  const componentName = component?.name ?? "Component";
  if (typeof type !== "string" || type === "") {
    throw new Error(
      `${componentName}: A non-empty string \`type\` is required for component registration, got ${type}`
    );
  }
}
class ReactRuntime extends RuntimeCore {
  registerComponent(component, {
    type,
    label,
    icon = ComponentIcon.Cube,
    hidden = false,
    props
  }) {
    validateComponentType(type, component);
    const unregisterComponent = this.store.dispatch(
      registerComponentEffect(type, { label, icon, hidden }, props ?? {})
    );
    const unregisterReactComponent = this.store.dispatch(
      registerReactComponentEffect(type, component)
    );
    return () => {
      unregisterComponent();
      unregisterReactComponent();
    };
  }
  constructor({ breakpoints } = {}) {
    super({ breakpoints });
    registerBuiltinComponents(this);
  }
}
export {
  ReactRuntime
};
//# sourceMappingURL=react-runtime.js.map